import { CreateOrEditWorkerSettingsPage } from "./CreateOrEditWorkerSettingsPage";
interface AddWorkerPageProps {
    spaceId: string;
}
export function AddWorkerPage({ spaceId }: AddWorkerPageProps) {
    return <CreateOrEditWorkerSettingsPage spaceId={spaceId}/>;
}
